import AbstractRequestTask from "../AbstractRequestTask";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class CertificateTask extends AbstractRequestTask {

  constructor(url, params, isPOST = false, headerCustomData = null) {
    super();
    this._url = url ? url : "https://widevine-vod.clarovideo.net/licenser/getcertificate";
    this._params = params || {}
    this.isPOST = isPOST;
    this.headerCustomData = headerCustomData;
  }

  getMethod() {
    return this.isPOST ? 'POST' : 'GET';
  }

  getHeaders() {
    if(!this.isPOST) {
      return {  };
    }
    else {
      if(this.headerCustomData) return this.headerCustomData;
    }
  }

  getUrl() {
    return this._url;
  }

  getParams() {
    const params = super.getParams();
    return this._params;
  }

  getResponseType(){
    return "arraybuffer";
  }

  success(data, b) {
    this.resolve(data);
  }

  isValid(data) {
    return true;
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default CertificateTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/video/CertificateTask.js